import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";

@ModuleName("ShoppingCartDateInputTriple")
export class ShoppingCartDateInputTriple implements AxInit {
    private initData: ShoppingCartDateInputTripleInit;

    constructor(
        protected _dateInitData = new BirthDateInitData()
    ) {
    }

    AxInit(init: ShoppingCartDateInputTripleInit): void {

            this.initData = init;
            $('.positionPersonalisation_birthday').each((i, e) => {
                let cartEntryId = $(e).attr('data-for-entry');
                let datePatternId = $(`#datePatternId_${cartEntryId}`).val();
                let dateInitData = {
                    birthdayPattern: datePatternId.toString(),
                    outputTarget: `input[type="hidden"]#DateOfBirthCi_${cartEntryId}`,
                    parentId: `#needPersonId_${cartEntryId}`
                };
                AxLoad.LoadModule('AxBirthDateInputTriple', dateInitData);
            });
    }
}
class ShoppingCartDateInputTripleInit {
    customerSignedIn?: boolean;
}

class BirthDateInitData {
    birthdayPattern: string;
    parentId: string;
    outputTarget: string;
    setDay: string;
    setMonth: string;
    setYear: string;
    setBirthDate: string;
}